import { createContext } from "react";
const AboutUsContext = createContext({});
export default AboutUsContext;
